import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment/moment';
import { Badge } from 'reactstrap';
import { getWorkerInterview, submitInterview } from '../../../actions';
import { createNewInterviewAction } from '../../../actions/workers';
import { getDetailedUser } from '../../../actions/users';
import { GET_WORKER_DETAILS_SUCCESS } from '../../../actions/actionTypes';
import { combineDateTime } from '../../../helpers/date';
import { uiDateFormat, hoursMinutesSecondsFormat, yearMonthDayFormat } from '../../../constants/date';
import UpdateInterview from './UpdateInterview';
import { taxTypes } from '../../../constants/companies';
import { links } from '../../../constants/general';

class WorkerInterview extends Component {
  static propTypes = {
    workerId: PropTypes.number.isRequired,
    getWorkerInterview: PropTypes.func.isRequired,
    submitInterview: PropTypes.func.isRequired
  };

  state = {
    interview: null,
    interview_comment: '',
    interviewDecision: '', // can also be 'pass' or 'decline'
    updateInterviewIsShown: false,
    isLoading: false,
    tax_type: taxTypes.W2
  };

  componentDidMount () {
    this.getInterview();
  };

  getInterview = () => {
    const { getWorkerInterview, workerId } = this.props;
    getWorkerInterview(workerId).then(data => {
      if (data) {
        const interview_date_time = combineDateTime(data.interview_date, data.interview_time);
        const interview = {
          ...data,
          interview_date_time,
          interviewDateUi: moment.utc(interview_date_time).format(uiDateFormat)
        };
        this.setState({ interview });
      }
    });
  };

  showUpdateInterview = () => {
    this.setState({ updateInterviewIsShown: true });
  };

  handleChangeDecision = event => {
    this.setState({
      interviewDecision: event.target.value
    });
  };

  handleChangeComment = event => {
    this.setState({
      interview_comment: event.target.value
    });
  };

  submitInterviewDecision = start_checkr => {
    const { workerId, createNewInterviewAction } = this.props;
    const { interview } = this.state;
    this.setState({ isLoading: true });
    if (interview) {
      this.updateInterview(interview.id, start_checkr);
    } else {
      // create new interview:
      const interview_date = moment().format(yearMonthDayFormat); // we get date in format YYYY-MM-DD for server request
      const interview_time = moment().format(hoursMinutesSecondsFormat);
      const newInterviewData = {
        interview_date,
        interview_time,
        user_id: workerId
      };
      createNewInterviewAction(newInterviewData).then(newInterview => {
        if (!newInterview.error) {
          this.updateInterview(newInterview.id, start_checkr);
        }
      });
    }
  };

  updateInterview = (id, start_checkr) => {
    const { workerId, submitInterview, getDetailedUser } = this.props;
    const { interview_comment, interviewDecision, tax_type } = this.state;
    const passed = interviewDecision === 'pass';
    submitInterview({
      id,
      passed,
      interview_comment,
      start_checkr,
      tax_type
    }).then(() => {
      this.setState({ isLoading: false });
      getDetailedUser(workerId, GET_WORKER_DETAILS_SUCCESS);
      this.getInterview();
    });
  };

  onChange = (name, value) => this.setState({ [name]: value });

  render () {
    const { interview, interview_comment, interviewDecision, updateInterviewIsShown, tax_type, isLoading } = this.state;
    let isCompleted = false;
    let status = '';
    if (interview) {
      isCompleted = moment().isAfter(interview.interview_date_time);
      if (interview.passed !== null) {
        status = interview.passed ? 'Passed' : 'Declined';
      } else {
        status = isCompleted ? 'No Decision' : 'Scheduled';
      }
    }

    const _renderDetails = () => {
      return (
        <div>
          <div className="section-header-wrapper">
            <h4>Other Details</h4>
          </div>
          <div className="section-row">
            <iframe
              className="iframe-details-wrapper"
              src={`${links.details}?id=${this.props.workerId}`}
              title="details-iframe"
            />
          </div>
        </div>
      );
    };
    return (
      <section>
        <h4 className='section-header'>Interview</h4>
        { interview ? (
          <div>
            <p>{interview.interviewDateUi}</p>
            <div>
              <h3 className='interview-status'>
                <Badge color={status === 'Passed' ? 'success' : status === 'Declined' ? 'danger' : 'info'}>
                  {status}
                </Badge>
              </h3>
              { interview.interview_comment && <p>{interview.interview_comment}</p> }
            </div>
            { interview.passed === null && (
              <UpdateInterview
                isShown
                isLoading={isLoading}
                interview={interview}
                interview_comment={interview_comment}
                interviewDecision={interviewDecision}
                tax_type={tax_type}
                onChange={this.onChange}
                handleChangeDecision={this.handleChangeDecision}
                handleChangeComment={this.handleChangeComment}
                submitInterviewDecision={this.submitInterviewDecision}
              />
            )}
          </div>
        ) : (
          <div>
            <p>There is no interview for the worker</p>
            <div
              className='button button-primary'
              onClick={this.showUpdateInterview}
            >Start Interview</div>
            <UpdateInterview
              isShown={updateInterviewIsShown}
              isLoading={isLoading}
              interview={interview}
              tax_type={tax_type}
              onChange={this.onChange}
              interview_comment={interview_comment}
              interviewDecision={interviewDecision}
              handleChangeDecision={this.handleChangeDecision}
              handleChangeComment={this.handleChangeComment}
              submitInterviewDecision={this.submitInterviewDecision}
            />
          </div>
        )}
        <div className="section-row flex-wrap">
          <p>___________________________________________________</p>
        </div>
        <div className="section-row flex-wrap">
          &nbsp;
        </div>
        {_renderDetails()}
      </section>
    );
  }
}

const mapDispatchToProps = {
  getWorkerInterview,
  submitInterview,
  createNewInterviewAction,
  getDetailedUser
};

export default connect(null, mapDispatchToProps)(WorkerInterview);



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/WorkerInterview.js